import { FormConfig } from './types';

export const events: FormConfig = {
  dialogSize: 'small',
  sections: [
    {
      columns: 1,
      heading: 'General Information',
      subheading: '',
      fields: [
        {
          id: 'momentType',
          name: 'momentType',
          label: 'Type of Release/Moment',
          type: 'api_dropdown',
          required: false,
          api: 'momentTypes'
        },
        {
          id: 'momentName',
          name: 'momentName',
          label: 'Release or Moment Name  ',
          type: 'text',
          required: true
        },
        {
          id: 'momentStartDate',
          name: 'momentStartDate',
          label: 'Moment Start Date',
          type: 'datepicker',
          required: true
        },
        {
          id: 'momentEndDate',
          name: 'momentEndDate',
          label: 'Moment End Date',
          type: 'datepicker',
          required: true
        }
      ]
    }
  ]
};
